import type { RecoveryStatus as RecoveryStatusModel } from '../recovery';
import { Brand } from './Brand';
import { RecoveryStatus } from './RecoveryStatus';
import { SessionTimer } from './SessionTimer';

export interface SessionHeaderProps {
  readonly roomCode: string;
  readonly recovery: RecoveryStatusModel | null;
  readonly expiresAt: string | null;
  readonly role: 'host' | 'viewer';
  readonly onLeave: () => void;
  readonly onRetry: () => void;
}

export function SessionHeader({
  roomCode,
  recovery,
  expiresAt,
  role,
  onLeave,
  onRetry,
}: SessionHeaderProps) {
  return (
    <header class="session-header">
      <Brand />
      <div class="session-header__center">
        {recovery ? (
          <RecoveryStatus status={recovery} onRetry={onRetry} />
        ) : (
          <span class="connection-chip" role="status">
            <span aria-hidden="true" />
            Connecting…
          </span>
        )}
      </div>
      <div class="session-header__room">
        <SessionTimer expiresAt={expiresAt} />
        <span class="session-header__label">Room</span>
        <strong aria-label={`Room code ${roomCode}`}>{formatRoomCode(roomCode)}</strong>
        {role === 'viewer' ? (
          <button class="header-leave" type="button" onClick={onLeave}>
            Leave
          </button>
        ) : null}
      </div>
    </header>
  );
}

export function formatRoomCode(value: string): string {
  return value.length === 6 ? `${value.slice(0, 3)} ${value.slice(3)}` : value;
}
